<template>
  <modal :name="name"
         :adaptive="true"
         height="auto"
         width="380"
         @before-open="beforeOpen">
    <div v-if="prospect" class="ut-px-10 ut-pt-12 ut-pb-8">

      <div v-show="page == 1">
        <h2 class="title">Remove this prospect?</h2>
          <p class="ut-py-3 ut-capitalize">
          {{ prospectFullName }} - {{ contactPropertyAddress || 'Address unknown'  }}</p>
          <div class="form-group">
            <textarea v-model="removeReason"
                      v-gaEvent="{ category: gacategory,
                                   action: 'Contact card - remove'}"
                      placeholder="Add a reason for removing"
                      class="ut-h-16">
            </textarea>
        </div>
        <div class="ut-pt-6">
          <button @click="removeProspect()"
                  v-gaEvent="{ category: gacategory,
                                action: 'Remove prospect card - comfrim'}"
                  class="btn btn-green">Confirm</button>
          <button @click="closeModal()"
                  v-gaEvent="{ category: gacategory,
                                action: 'Remove prospect card - cancel'}"
                  class="btn btn-small white-bg ut-ml-4">Cancel</button>
        </div>
      </div>
      <div v-show="page == 2" class="ut-text-center ut-px-3">
        <img class="ut-mb-8" src="@/assets/images/moved-to-follow-ups.svg">
        <h2 class="title">Prospect Removed</h2>
        <p class="ut-mb-6 ut-capitalize">
          {{ prospectFullName }} was removed as a prospect</p>
        <button class="btn btn-small white-bg ut-ml-4"
                v-gaEvent="{ category: gacategory,
                             action: 'Remove prospect card - back to prospects'}"
                @click="closeModal()">Close</button>
      </div>


    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex';
import ProspectStatusType from '@/Mapper/ProspectStatusType';
import { ProspectActivityActionTypeId } from '@/Mapper/ProspectActivityActionType';

export default {
  name: 'ProspectingRemoveProspectModal',
  components: { },
  props: {
    agentId: {
      required: true,
    },
  },
  data() {
    return {
      name: 'prospecting-remove-prospect-modal',
      page: 1,
      removeReason: '',
      prospect: null,
      topActivity: null,
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  computed: {
    contactPropertyAddress() {
      if (this.topActivity && this.topActivity.contactPropertyAddress) {
        return this.$options.filters.address(this.topActivity.contactPropertyAddress, true) || null;
      }

      if (this.topActivity
        && this.topActivity.actionType.activityActionTypeId === ProspectActivityActionTypeId.oaMatch
        && !this.topActivity.contactPropertyAddress) {
        return 'Active near your agency';
      }

      return null;
    },
    prospectFullName() {
      return `${this.prospect.contact.firstName}${this.prospect.contact.lastName ? ` ${this.prospect.contact.lastName}` : ''}`;
    },
  },
  methods: {
    ...mapActions('prospectStore', [
      'createStatus',
    ]),
    closeModal() {
      this.page = 1;
      this.$modal.hide(this.name);
    },
    beforeOpen(event) {
      this.page = 1;
      this.prospect = event.params.prospect;
      this.topActivity = event.params.topActivity;
    },
    removeProspect() {
      // create removed status
      const payload = {
        prospectKey: this.prospect.key,
        statusTypeId: ProspectStatusType.removed,
        creatorUserId: this.userid,
        description: this.removeReason,
        prospect: this.prospect,
      };

      console.log(payload);
      this.createStatus(payload).then(() => {
        this.page = 2;
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  @apply ut-font-bold ut-mb-6;
  font-size: 20px;

}

hr {
  @apply ut-border-t ut-opacity-50 ut-w-full ut-h-auto;
  border-color: #979797;
}

.address {
  @apply ut-my-6 ut-flex ut-font-bold;
}

.property-details {
  @apply ut-flex ut-my-6;

  ul {
    @apply  ut-flex;

    li {
      @apply ut-ml-6;

      img {
        vertical-align: sub;
      }
    }
  }
}

.contact-details {
  @apply ut-my-6;

  ul {
    li {
      @apply ut-my-6;

      a {
        @apply ut-text-green-400;
      }
    }
  }
}
</style>
